(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[261],{

/***/ 24050:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apartamentos-a-venda/[slug]",
      function () {
        return __webpack_require__(78394);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37265);
/* harmony import */ var _bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67202);
/* harmony import */ var _bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function Banner(param) {
    var image = param.image, _children = param.children, children = _children === void 0 ? "" : _children, _width = param.width, width = _width === void 0 ? "100%" : _width, _height = param.height, height = _height === void 0 ? "fit-content" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bannerContainer),
        style: {
            width: width,
            height: height
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: (image === null || image === void 0 ? void 0 : image.src) || "/img/loading-wall.gif",
                loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__/* .customLoader */ .l,
                width: width,
                layout: "fill",
                objectFit: "cover",
                quality: 100,
                alt: "Hype Empreendimentos",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default().childrenContainer),
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 59000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ButtonDefault; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _buttonDefault_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90050);
/* harmony import */ var _buttonDefault_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_buttonDefault_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function ButtonDefault(param) {
    var url = param.url, text = param.text, aria = param.aria, _target = param.target, target = _target === void 0 ? "_self" : _target;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_buttonDefault_module_scss__WEBPACK_IMPORTED_MODULE_2___default().buttonContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: url !== null && url !== void 0 ? url : "",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                target: target,
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    "aria-label": aria,
                    children: text
                })
            })
        })
    });
}


/***/ }),

/***/ 51012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardImovel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37265);
/* harmony import */ var _utils_formatCoin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20362);
/* harmony import */ var _cardImovel_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30985);
/* harmony import */ var _cardImovel_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_cardImovel_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* provided dependency */ var process = __webpack_require__(83454);







var parse = __webpack_require__(30488);
function CardImovel(param) {
    var imovel = param.imovel;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    if (!imovel) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: {
            pathname: "/apartamentos-a-venda/".concat(imovel.slug),
            query: router.query
        },
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_cardImovel_module_scss__WEBPACK_IMPORTED_MODULE_4___default().cardImovel),
            role: "button",
            onKeyDown: function(event) {
                return event.key === "Enter" && event.currentTarget.click();
            },
            tabIndex: 0,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                    className: (_cardImovel_module_scss__WEBPACK_IMPORTED_MODULE_4___default().image),
                    children: [
                        imovel.foto && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: imovel.thumbnail || "/img/image_icon.png",
                            loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_5__/* .customLoader */ .l,
                            alt: "Imagem do ".concat(imovel.nome),
                            objectFit: "cover",
                            layout: "responsive",
                            width: 300,
                            height: 300,
                            priority: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                            children: "Imagem do ".concat(imovel.nome)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_cardImovel_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                    children: [
                        imovel.faseObra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            children: imovel.faseObra
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: imovel.nome
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "".concat(imovel.cidade, " - ").concat(imovel.bairro)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: parse(imovel.variacaoTipologia)
                        }),
                        process.env.FEATURE_FLAG_DATA_ENTREGA ? imovel.dataDeEntrega && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                "Data de Entrega:",
                                " ".concat(new Date(imovel.dataDeEntrega).toLocaleDateString("pt-BR", {
                                    month: "2-digit",
                                    year: "numeric"
                                }))
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: parse(imovel.numeroDeGaragensDescricao)
                        }),
                        imovel.faseObra !== "Pr\xe9-lan\xe7amento" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "A partir de ".concat((0,_utils_formatCoin__WEBPACK_IMPORTED_MODULE_6__/* .valueToBRL */ .o)(imovel.valorMinimo), " at\xe9 ").concat((0,_utils_formatCoin__WEBPACK_IMPORTED_MODULE_6__/* .valueToBRL */ .o)(imovel.valorMaximo))
                        })
                    ]
                })
            ]
        })
    }, imovel.id);
}


/***/ }),

/***/ 25768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DepoimentosCarousel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_material_ui_carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13056);
/* harmony import */ var react_material_ui_carousel__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_material_ui_carousel__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37265);
/* harmony import */ var _BannerDefault__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50121);
/* harmony import */ var _carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84746);
/* harmony import */ var _carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4__);






function DepoimentosCarousel(param) {
    var _depoimentos = param.depoimentos, depoimentos = _depoimentos === void 0 ? [] : _depoimentos;
    if (!Array.isArray(depoimentos)) {
        depoimentos = [];
    }
    if (true) {
        Array.from(document.getElementsByClassName("MuiButtonBase-root")).forEach(function(element) {
            var ref;
            var ariaElement = (ref = element.getAttribute("aria-label")) === null || ref === void 0 ? void 0 : ref.slice(0, 18);
            if (ariaElement && ariaElement === "carousel indicator") element.setAttribute("tabindex", "-1");
        });
    }
    if (!depoimentos.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BannerDefault__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        image: {
            src: "/img/backgroundpolitica.webp"
        },
        width: "100%",
        height: "fit-content",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().section),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: "Experi\xeancias Extraordin\xe1rias"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_material_ui_carousel__WEBPACK_IMPORTED_MODULE_2___default()), {
                    navButtonsAlwaysVisible: true,
                    autoPlay: true,
                    className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().slider),
                    children: depoimentos.map(function(depoimento) {
                        var ref, ref1, ref2, ref3;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().slide),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: depoimento === null || depoimento === void 0 ? void 0 : depoimento.depoimento
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().cliente),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                            className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().image),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                    alt: depoimento === null || depoimento === void 0 ? void 0 : depoimento.nome_cliente,
                                                    src: (depoimento === null || depoimento === void 0 ? void 0 : (ref = depoimento.imagem) === null || ref === void 0 ? void 0 : (ref1 = ref.sizes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.url) || (depoimento === null || depoimento === void 0 ? void 0 : (ref3 = depoimento.imagem) === null || ref3 === void 0 ? void 0 : ref3.url),
                                                    loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_5__/* .customLoader */ .l,
                                                    layout: "responsive",
                                                    width: "60",
                                                    height: "60",
                                                    priority: true
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figcaption", {
                                                    children: [
                                                        "Imagem:",
                                                        "Foto do cliente ".concat(depoimento.nome_cliente)
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().infoClient),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    children: depoimento.nome_cliente
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: (_carouselDepoimentos_module_scss__WEBPACK_IMPORTED_MODULE_4___default().emp),
                                                    children: depoimento.empreendimento
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, depoimento === null || depoimento === void 0 ? void 0 : depoimento.nome_cliente);
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 14854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GaleryMobileCarousel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var simple_react_lightbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34930);
/* harmony import */ var react_material_ui_carousel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13056);
/* harmony import */ var react_material_ui_carousel__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_material_ui_carousel__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37265);
/* harmony import */ var _utils_ImageFindSizes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34873);
/* harmony import */ var _galeryMobileCarousel_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49593);
/* harmony import */ var _galeryMobileCarousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_galeryMobileCarousel_module_scss__WEBPACK_IMPORTED_MODULE_4__);







function GaleryMobileCarousel(param) {
    var images = param.images, objectFit = param.objectFit;
    if (!images) return null;
    var options = {
        settings: {
            overlayColor: "rgba(25,136,124,0.71)",
            autoplaySpeed: 3000,
            transitionSpeed: 900
        },
        buttons: {
            showThumbnailsButton: false,
            showDownloadButton: false,
            showNextButton: true,
            showPrevButton: true,
            showAutoplayButton: false
        },
        caption: {
            showCaption: false,
            captionColor: "#a6cfa5",
            captionFontFamily: "Raleway, sans-serif",
            captionFontWeight: "300",
            captionTextTransform: "uppercase"
        },
        thumbnails: {
            showThumbnails: false
        }
    };
    var showControls = function() {
        var SRLStage = document.getElementsByClassName("SRLStage")[0];
        var buttons = SRLStage.getElementsByTagName("button");
        for(var i = 0; i < buttons.length; i += 1){
            if (buttons[i].classList.contains("SRLNextButton") || buttons[i].classList.contains("SRLPrevButton")) {
                buttons[i].style.display = "block";
                buttons[i].style.marginTop = "40px";
            }
        }
    };
    if (true) {
        Array.from(document.getElementsByClassName("MuiButtonBase-root")).forEach(function(element) {
            var ref;
            var ariaElement = (ref = element.getAttribute("aria-label")) === null || ref === void 0 ? void 0 : ref.slice(0, 18);
            if (ariaElement && ariaElement === "carousel indicator") element.setAttribute("tabindex", "-1");
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(simple_react_lightbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(simple_react_lightbox__WEBPACK_IMPORTED_MODULE_2__/* .SRLWrapper */ .Iv, {
            options: options,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_material_ui_carousel__WEBPACK_IMPORTED_MODULE_3___default()), {
                navButtonsAlwaysVisible: true,
                autoPlay: true,
                className: (_galeryMobileCarousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default().slider),
                children: images.map(function(img) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_galeryMobileCarousel_module_scss__WEBPACK_IMPORTED_MODULE_4___default().slide),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    alt: (ref = img.imagem) === null || ref === void 0 ? void 0 : ref.titulo,
                                    src: (0,_utils_ImageFindSizes__WEBPACK_IMPORTED_MODULE_5__/* .imagemSizes */ .xQ)(img) || "",
                                    loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_6__/* .customLoader */ .l,
                                    layout: "responsive",
                                    objectFit: objectFit,
                                    width: "600",
                                    height: "350",
                                    style: {
                                        cursor: "pointer"
                                    },
                                    onClick: function() {
                                        return showControls();
                                    },
                                    priority: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                                    children: (ref1 = img.imagem) === null || ref1 === void 0 ? void 0 : ref1.titulo
                                })
                            ]
                        })
                    }, img.id);
                })
            })
        })
    });
}


/***/ }),

/***/ 28967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CadastroForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89583);
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91749);
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_text_mask__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_toastNotification__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61249);
/* harmony import */ var _utils_validationForm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70753);
/* harmony import */ var _cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43465);
/* harmony import */ var _cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* provided dependency */ var process = __webpack_require__(83454);












function CadastroForm() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), errorMessage = ref[0], setErrorMessage = ref[1];
    var _asPath;
    var initialState = {
        empreendimento: (_asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().asPath) !== null && _asPath !== void 0 ? _asPath : "",
        email: "",
        nome: "",
        telefone: "",
        momento: "",
        horario: "",
        canal: "",
        criadoEm: new Date()
    };
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialState), contactFormData = ref1[0], setContactFormData = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var script = document.createElement("script");
        script.src = "https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(event) {
            var error, form;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        return [
                            4,
                            _utils_validationForm__WEBPACK_IMPORTED_MODULE_5__/* .validationFormContact.validate */ .y.validate(contactFormData)
                        ];
                    case 1:
                        error = _state.sent().error;
                        if (error) {
                            setErrorMessage(error.details[0].message);
                            setTimeout(function() {
                                setErrorMessage("");
                            }, 5000);
                        } else {
                            try {
                                new _utils_toastNotification__WEBPACK_IMPORTED_MODULE_4__/* .Toast */ .F({
                                    message: "Enviado com sucesso!",
                                    color: _utils_toastNotification__WEBPACK_IMPORTED_MODULE_4__/* .ToastColor.Success */ .P.Success,
                                    time: 5000
                                });
                                form = document.getElementById("form");
                                form.reset();
                                setContactFormData(initialState);
                            } catch (err) {
                                new _utils_toastNotification__WEBPACK_IMPORTED_MODULE_4__/* .Toast */ .F({
                                    message: "Erro no envio. Entre em contato conosco!",
                                    color: _utils_toastNotification__WEBPACK_IMPORTED_MODULE_4__/* .ToastColor.Danger */ .P.Danger,
                                    time: 5000
                                });
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var canais = [
        "E-mail",
        "Telefone",
        "WhatsApp"
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8___default().formContainer),
        id: "formContainer",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: "Quer saber mais?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8___default().subtitle),
                children: "Entre em contato em receba as informa\xe7\xf5es!"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                onSubmit: handleSubmit,
                id: "form",
                name: (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().asPath,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fieldItem),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "text",
                                onChange: function(e) {
                                    return setContactFormData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, contactFormData), {
                                        nome: e.target.value
                                    }));
                                },
                                id: "nome",
                                name: "nome",
                                required: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: "nome",
                                children: "Nome Completo"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fieldItem),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "email",
                                onChange: function(e) {
                                    return setContactFormData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, contactFormData), {
                                        email: e.target.value
                                    }));
                                },
                                id: "email",
                                name: "email",
                                required: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: "email",
                                children: "Email"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fieldItem),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_text_mask__WEBPACK_IMPORTED_MODULE_3___default()), {
                                mask: [
                                    "(",
                                    /[1-9]/,
                                    /\d/,
                                    ")",
                                    " ",
                                    /\d?/,
                                    " ",
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    "-",
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/
                                ],
                                onChange: function(e) {
                                    return setContactFormData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, contactFormData), {
                                        telefone: e.target.value
                                    }));
                                },
                                id: "telefone",
                                name: "telefone",
                                required: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: "telefone",
                                children: "Telefone"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fieldItem),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                onChange: function(e) {
                                    return setContactFormData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, contactFormData), {
                                        momento: e.target.value
                                    }));
                                },
                                "aria-label": "Momento",
                                id: "momento",
                                name: "momento",
                                required: true,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        selected: true,
                                        value: "",
                                        "aria-label": "option"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: "Pronto para uma proposta",
                                        children: "Pronto para uma proposta"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: "Apenas Pesquisando",
                                        children: "Apenas pesquisando"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: "Visitando im\xf3veis",
                                        children: "Visitando im\xf3veis"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: "momento",
                                children: "Voc\xea est\xe1..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fieldItem),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "text",
                                onChange: function(e) {
                                    return setContactFormData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, contactFormData), {
                                        horario: e.target.value
                                    }));
                                },
                                id: "horario",
                                name: "horario",
                                placeholder: "Ex.: Ap\xf3s 10h da manh\xe3"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                htmlFor: "horario",
                                children: "Melhor hor\xe1rio para contato"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fieldCanal),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                children: "Canal preferencial de contato"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: canais.map(function(can) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                        htmlFor: can,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "checkbox",
                                                onChange: function() {
                                                    return setContactFormData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, contactFormData), {
                                                        canal: can
                                                    }));
                                                },
                                                id: can,
                                                name: "canal",
                                                "aria-label": "".concat(can, " como melhor canal de contato"),
                                                checked: can === contactFormData.canal
                                            }),
                                            can
                                        ]
                                    }, can);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8___default().errorMessage),
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        "aria-label": "Enviar formul\xe1rio de contato",
                        type: "submit",
                        children: "Enviar"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8___default().contacts),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: "Central de Vendas"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                href: "https://api.whatsapp.com/send?l=pt_BR&phone=".concat(process.env.NEXT_PUBLIC_ZAPIER_PHONE_NUMBER, "&text=Ol\xe1! Tenho interesse em conhecer empreendimentos da Hype!"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaWhatsapp */ .xpo, {
                                        className: (_cadastroDefault_module_scss__WEBPACK_IMPORTED_MODULE_8___default().iconContact)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "(41) 99859-0963"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 38280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MetaTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function MetaTags(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    if (!data) return null;
    var ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, _descricao, ref21, ref22;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    " ",
                    (ref8 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref8 !== void 0 ? ref8 : "",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: (ref9 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref9 !== void 0 ? ref9 : ""
            }, "metadescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "name",
                content: (ref10 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref10 !== void 0 ? ref10 : ""
            }, "googlename"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "description",
                content: (ref11 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref11 !== void 0 ? ref11 : ""
            }, "googledescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: (ref12 = data === null || data === void 0 ? void 0 : (ref = data.imagem) === null || ref === void 0 ? void 0 : ref.url) !== null && ref12 !== void 0 ? ref12 : ""
            }, "googleimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: (ref13 = data === null || data === void 0 ? void 0 : data.rota) !== null && ref13 !== void 0 ? ref13 : ""
            }, "ogurl"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }, "ogtype"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: (ref14 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref14 !== void 0 ? ref14 : ""
            }, "ogtitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: (ref15 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref15 !== void 0 ? ref15 : ""
            }, "ogdesc"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: (ref16 = data === null || data === void 0 ? void 0 : (ref1 = data.imagem) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref16 !== void 0 ? ref16 : ""
            }, "image"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                itemProp: "image",
                content: (ref17 = data === null || data === void 0 ? void 0 : (ref2 = data.imagem) === null || ref2 === void 0 ? void 0 : ref2.url) !== null && ref17 !== void 0 ? ref17 : ""
            }, "ogimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: (ref18 = data === null || data === void 0 ? void 0 : (ref3 = data.imagem) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.width) === null || ref4 === void 0 ? void 0 : ref4.toString()) !== null && ref18 !== void 0 ? ref18 : ""
            }, "ogimagewidth"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: (ref19 = data === null || data === void 0 ? void 0 : (ref5 = data.imagem) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.height) === null || ref6 === void 0 ? void 0 : ref6.toString()) !== null && ref19 !== void 0 ? ref19 : ""
            }, "ogimageheight"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Hype Empreendimentos"
            }, "ogsitename"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: (ref20 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref20 !== void 0 ? ref20 : ""
            }, "twittertitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: (_descricao = data.descricao) !== null && _descricao !== void 0 ? _descricao : ""
            }, "twitterdescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: (ref21 = data === null || data === void 0 ? void 0 : (ref7 = data.imagem) === null || ref7 === void 0 ? void 0 : ref7.url) !== null && ref21 !== void 0 ? ref21 : ""
            }, "twitterimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:domain",
                content: "hypeempreendimentos.com.br"
            }, "twitterdomain"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: (ref22 = data === null || data === void 0 ? void 0 : data.rota) !== null && ref22 !== void 0 ? ref22 : ""
            }, "twitterurl")
        ]
    });
}


/***/ }),

/***/ 40663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Cadastro; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_BannerDefault__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50121);
/* harmony import */ var _components_Forms_CadastroDefault__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28967);
/* harmony import */ var _cadastro_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48247);
/* harmony import */ var _cadastro_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_cadastro_module_scss__WEBPACK_IMPORTED_MODULE_4__);





function Cadastro() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BannerDefault__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        image: {
            src: "/img/fundohistsobrenos.webp"
        },
        width: "100%",
        height: "fit-content",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_cadastro_module_scss__WEBPACK_IMPORTED_MODULE_4___default().cadastroForm),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Forms_CadastroDefault__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        })
    });
}


/***/ }),

/***/ 26015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Conceito; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_formatCoin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20362);
/* harmony import */ var _conceito_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66956);
/* harmony import */ var _conceito_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_conceito_module_scss__WEBPACK_IMPORTED_MODULE_1__);



var parse = __webpack_require__(30488);
function Conceito(param) {
    var conceito = param.conceito, valorMinimo = param.valorMinimo, valorMaximo = param.valorMaximo, faseObra = param.faseObra;
    if (!conceito) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_conceito_module_scss__WEBPACK_IMPORTED_MODULE_1___default().section),
        children: [
            parse(conceito),
            faseObra !== "Pr\xe9-lan\xe7amento" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_conceito_module_scss__WEBPACK_IMPORTED_MODULE_1___default().preco),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: "Unidades a partir de ".concat((0,_utils_formatCoin__WEBPACK_IMPORTED_MODULE_2__/* .valueToBRL */ .o)(valorMinimo), " at\xe9 ").concat((0,_utils_formatCoin__WEBPACK_IMPORTED_MODULE_2__/* .valueToBRL */ .o)(valorMaximo))
                })
            }),
            faseObra !== "Pr\xe9-lan\xe7amento" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                children: "Os pre\xe7os das unidades podem variar conforme disponibilidade e data de consulta."
            })
        ]
    });
}


/***/ }),

/***/ 14317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Diferenciais; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tab/Tab.js
var Tab = __webpack_require__(75316);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
;// CONCATENATED MODULE: ./components/Tabs/TabsDiferenciais/index.tsx







function BasicTabs(param) {
    var contentTab1 = param.contentTab1;
    var TabPanel = function TabPanel(props) {
        var children = props.children, value = props.value, index = props.index, other = _objectWithoutProperties(props, [
            "children",
            "value",
            "index"
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            role: "tabpanel",
            hidden: value !== index,
            id: "simple-tabpanel-".concat(index),
            "aria-labelledby": "simple-tab-".concat(index)
        }, other), {
            children: value === index && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    p: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    children: children
                })
            })
        }));
    };
    var a11yProps = function a11yProps(index) {
        return {
            id: "simple-tab-".concat(index),
            "aria-controls": "simple-tabpanel-".concat(index)
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    borderBottom: 1,
                    borderColor: "divider"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    label: "Informa\xe7\xf5es"
                }, a11yProps(0)), {
                    sx: {
                        textTransform: "none",
                        color: "#353e52",
                        fontSize: "1.5rem",
                        fontFamily: "Barlow, sans-serif"
                    }
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, {
                value: 0,
                index: 0,
                children: contentTab1
            })
        ]
    });
}

// EXTERNAL MODULE: ./utils/customLoaderImage.ts
var customLoaderImage = __webpack_require__(37265);
// EXTERNAL MODULE: ./utils/ImageFindSizes.ts
var ImageFindSizes = __webpack_require__(34873);
// EXTERNAL MODULE: ./pages/apartamentos-a-venda/[slug]/diferenciais.module.scss
var diferenciais_module = __webpack_require__(12733);
var diferenciais_module_default = /*#__PURE__*/__webpack_require__.n(diferenciais_module);
;// CONCATENATED MODULE: ./pages/apartamentos-a-venda/[slug]/diferenciais.tsx







var parse = __webpack_require__(30488);
function Diferenciais(param) {
    var data = param.data;
    var ref = (0,react.useState)([]), listInfo = ref[0], setListInfo = ref[1];
    (0,react.useEffect)(function() {
        if ((data === null || data === void 0 ? void 0 : data.informacoesIcones) && (data === null || data === void 0 ? void 0 : data.informacoesItens)) {
            var infoList = data.informacoesItens.map(function(item, index) {
                return {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: data.informacoesIcones[index],
                            width: 40,
                            height: 40,
                            layout: "fixed",
                            objectFit: "fill",
                            alt: "\xcdcone de diferencial",
                            quality: 100,
                            priority: true
                        })
                    }, "item: ".concat(item)),
                    text: item
                };
            });
            setListInfo(infoList);
        }
    }, [
        data
    ]);
    if (!data) return null;
    var informacoesImagem = data.informacoesImagem;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (diferenciais_module_default()).section,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (diferenciais_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                    children: [
                        (informacoesImagem === null || informacoesImagem === void 0 ? void 0 : informacoesImagem.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (0,ImageFindSizes/* imagemSizes */.xQ)({
                                imagem: informacoesImagem
                            }) || "/img/loading-wall.gif",
                            loader: customLoaderImage/* customLoader */.l,
                            width: 920,
                            height: 1080,
                            layout: "responsive",
                            objectFit: "cover",
                            alt: informacoesImagem === null || informacoesImagem === void 0 ? void 0 : informacoesImagem.titulo,
                            sizes: "(max-width: 768px) 90vw, (max-width: 1200px) 50vw, 33vw",
                            quality: 100,
                            priority: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                            children: informacoesImagem === null || informacoesImagem === void 0 ? void 0 : informacoesImagem.titulo
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicTabs, {
                contentTab1: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (diferenciais_module_default()).contentTab,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: listInfo && listInfo.map(function(info) {
                            return info.text && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: (diferenciais_module_default()).info,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (diferenciais_module_default()).icon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                        ]
                                    }),
                                    info.icon,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: parse(info.text)
                                    })
                                ]
                            }, info.text);
                        })
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 48249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Frasevendedora; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_BannerDefault__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50121);
/* harmony import */ var _fraseVendedora_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24191);
/* harmony import */ var _fraseVendedora_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_fraseVendedora_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var parse = __webpack_require__(30488);
function Frasevendedora(param) {
    var destaque = param.destaque;
    if (!destaque) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BannerDefault__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        image: {
            src: "/img/fundofrasevendedora.webp"
        },
        width: "100%",
        height: "fit-content",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_fraseVendedora_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: parse(destaque)
            })
        })
    });
}


/***/ }),

/***/ 70500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Galeria; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/simple-react-lightbox/dist/index.es.js
var index_es = __webpack_require__(34930);
// EXTERNAL MODULE: ./node_modules/react-loader-spinner/dist/module.js
var dist_module = __webpack_require__(12440);
// EXTERNAL MODULE: ./utils/customLoaderImage.ts
var customLoaderImage = __webpack_require__(37265);
// EXTERNAL MODULE: ./utils/ImageFindSizes.ts
var ImageFindSizes = __webpack_require__(34873);
// EXTERNAL MODULE: ./components/Carousel/GaleryDesktopCarousel/galeryDesktopCarousel.module.scss
var galeryDesktopCarousel_module = __webpack_require__(16360);
var galeryDesktopCarousel_module_default = /*#__PURE__*/__webpack_require__.n(galeryDesktopCarousel_module);
;// CONCATENATED MODULE: ./components/Carousel/GaleryDesktopCarousel/index.tsx










function GaleryDesktopCarousel(param) {
    var arrayItens = param.arrayItens;
    var ListaImg = function ListaImg(param) {
        var img = param.img, id = param.id;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (galeryDesktopCarousel_module_default()).image,
            tabIndex: -1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                tabIndex: -1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: img.imagem.titulo,
                        objectFit: "cover",
                        src: (0,ImageFindSizes/* imagemSizes */.xQ)(img) || "/img/image_icon.png",
                        loader: customLoaderImage/* customLoader */.l,
                        width: "480",
                        height: "480",
                        priority: true,
                        tabIndex: -1,
                        onLoadingComplete: function() {}
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("figcaption", {
                        children: [
                            "Imagem: Foto",
                            " ",
                            id,
                            " ",
                            "do empreendimento",
                            " ",
                            img.imagem.titulo
                        ]
                    })
                ]
            })
        });
    };
    var ref = (0,react.useState)(false), imagesLoaded = ref[0], setImagesLoaded = ref[1];
    var ref1 = (0,react.useState)(false), showMore = ref1[0], setShowMore = ref1[1];
    (0,react.useEffect)(function() {
        var isMounted = true;
        var loadImages = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!arrayItens || arrayItens.length === 0) {
                                if (isMounted) setImagesLoaded(true);
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                Promise.all(arrayItens.map(function(item) {
                                    return new Promise(function(resolve) {
                                        var img = new window.Image();
                                        img.src = item.imagem.url || "/img/image_icon.png";
                                        img.onload = function() {
                                            return resolve();
                                        };
                                    });
                                }))
                            ];
                        case 1:
                            _state.sent();
                            if (isMounted) setImagesLoaded(true);
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadImages() {
                return _ref.apply(this, arguments);
            };
        }();
        loadImages();
        return function() {
            isMounted = false;
        };
    }, [
        arrayItens
    ]);
    var options = {
        settings: {
            overlayColor: "rgba(25,136,124,0.71)",
            autoplaySpeed: 3000,
            transitionSpeed: 900
        },
        buttons: {
            showThumbnailsButton: false,
            showDownloadButton: false
        },
        caption: {
            showCaption: false
        },
        thumbnails: {
            showThumbnails: false
        }
    };
    var seeMore = function() {
        setShowMore(!showMore);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (galeryDesktopCarousel_module_default()).gallery,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SRLWrapper */.Iv, {
                options: options,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "containerImages",
                    className: (galeryDesktopCarousel_module_default()).containerImages,
                    children: [
                        !imagesLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_module/* RotatingLines */.s5, {
                            visible: true,
                            width: "96",
                            strokeColor: "#00bd97",
                            strokeWidth: "5",
                            animationDuration: "1.5",
                            ariaLabel: "rotating-lines-loading"
                        }),
                        imagesLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: arrayItens.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    style: {
                                        display: index < 6 || showMore ? "block" : "none"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListaImg, {
                                        img: item,
                                        id: item.id
                                    })
                                }, item.id);
                            })
                        }),
                        imagesLoaded && arrayItens.length > 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            "aria-label": "Ver mais imagens",
                            id: "moreBtn",
                            onClick: seeMore,
                            className: (galeryDesktopCarousel_module_default()).moreBtn,
                            children: showMore ? "Ver menos" : "Ver mais"
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./components/Carousel/GaleryMobileCarousel/index.tsx
var GaleryMobileCarousel = __webpack_require__(14854);
// EXTERNAL MODULE: ./hooks/useMedia.ts
var useMedia = __webpack_require__(55255);
// EXTERNAL MODULE: ./pages/apartamentos-a-venda/[slug]/galeria.module.scss
var galeria_module = __webpack_require__(97740);
var galeria_module_default = /*#__PURE__*/__webpack_require__.n(galeria_module);
;// CONCATENATED MODULE: ./pages/apartamentos-a-venda/[slug]/galeria.tsx






function Galeria(param) {
    var data = param.data;
    var isMobile = (0,useMedia/* default */.Z)("(max-width: 768px)");
    var ref = (0,react.useState)(1), tab = ref[0], setTab = ref[1];
    var ref1 = (0,react.useState)([]), arrayItens = ref1[0], setArrayItens = ref1[1];
    var clearState = (0,react.useCallback)(function() {
        return setArrayItens([]);
    }, [
        setArrayItens
    ]);
    var setTabItens = (0,react.useCallback)(function(tabNumber) {
        setTab(tabNumber);
        clearState();
        if (tabNumber === 1) {
            setArrayItens(data.galeria);
        } else if (tabNumber === 2) {
            setArrayItens(data.plantas);
        } else if (tabNumber === 3) {
            setArrayItens(data.obra);
        }
    }, [
        data,
        clearState,
        setTab,
        setArrayItens
    ]);
    (0,react.useEffect)(function() {
        setTabItens(1);
    }, [
        setTabItens
    ]);
    if (!data) return null;
    var galeria = data.galeria, plantas = data.plantas, obra = data.obra;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (galeria_module_default()).gallery,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (galeria_module_default()).tabs,
                children: [
                    galeria ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        role: "presentation",
                        onClick: function() {
                            return setTabItens(1);
                        },
                        className: tab === 1 ? (galeria_module_default()).tabClicked : (galeria_module_default()).tabNotClicked,
                        children: "Galeria"
                    }) : null,
                    plantas.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        role: "presentation",
                        onClick: function() {
                            return setTabItens(2);
                        },
                        className: tab === 2 ? (galeria_module_default()).tabClicked : (galeria_module_default()).tabNotClicked,
                        children: "Planta Baixa"
                    }) : null,
                    obra.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        role: "presentation",
                        onClick: function() {
                            return setTabItens(3);
                        },
                        className: tab === 3 ? (galeria_module_default()).tabClicked : (galeria_module_default()).tabNotClicked,
                        children: "Acompanhe a obra"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: tab === 1 ? "block" : "none"
                },
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GaleryMobileCarousel/* default */.Z, {
                    images: arrayItens,
                    objectFit: "cover"
                }, 1) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GaleryDesktopCarousel, {
                    arrayItens: arrayItens
                }, 1)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: tab === 2 ? "block" : "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GaleryMobileCarousel/* default */.Z, {
                    images: arrayItens,
                    objectFit: "cover"
                }, 2)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: tab === 3 ? "block" : "none"
                },
                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GaleryMobileCarousel/* default */.Z, {
                    images: arrayItens,
                    objectFit: "cover"
                }, 3) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GaleryDesktopCarousel, {
                    arrayItens: arrayItens
                }, 3)
            })
        ]
    });
}


/***/ }),

/***/ 78394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/BannerDefault/index.tsx
var BannerDefault = __webpack_require__(50121);
// EXTERNAL MODULE: ./components/Carousel/CarouselDepoimentos/index.tsx
var CarouselDepoimentos = __webpack_require__(25768);
// EXTERNAL MODULE: ./components/MetaTags/index.tsx
var MetaTags = __webpack_require__(38280);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./utils/convertDate.ts
// Classe para retornar data formatada em vários formatos


var ConvertDate = /*#__PURE__*/ function() {
    "use strict";
    function ConvertDate() {
        (0,_class_call_check/* default */.Z)(this, ConvertDate);
    }
    var _proto = ConvertDate.prototype;
    _proto.parseDateToMonthYearText = function parseDateToMonthYearText(dataEntrega) {
        var date = new Date(dataEntrega);
        var meses = [
            "janeiro",
            "fevereiro",
            "mar\xe7o",
            "abril",
            "maio",
            "junho",
            "julho",
            "agosto",
            "setembro",
            "outubro",
            "novembro",
            "dezembro"
        ];
        var formattedDate = "".concat(meses[date.getMonth()], " de ").concat(date.getFullYear());
        return formattedDate; // agosto de 2026
    };
    _proto.parseDateToMonthYear = function parseDateToMonthYear(dataEntrega) {
        var ref = (0,_sliced_to_array/* default */.Z)(dataEntrega.split("/"), 3), dia = ref[0], mes = ref[1], ano = ref[2];
        var date = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
        var formattedDate = "".concat(mes, "/").concat(date.getFullYear());
        return formattedDate; // 08/2026
    };
    return ConvertDate;
}();


// EXTERNAL MODULE: ./utils/customLoaderImage.ts
var customLoaderImage = __webpack_require__(37265);
// EXTERNAL MODULE: ./utils/ImageFindSizes.ts
var ImageFindSizes = __webpack_require__(34873);
// EXTERNAL MODULE: ./pages/apartamentos-a-venda/[slug]/cadastro.tsx
var cadastro = __webpack_require__(40663);
// EXTERNAL MODULE: ./pages/apartamentos-a-venda/[slug]/conceito.tsx
var _slug_conceito = __webpack_require__(26015);
// EXTERNAL MODULE: ./pages/apartamentos-a-venda/[slug]/diferenciais.tsx + 3 modules
var diferenciais = __webpack_require__(14317);
// EXTERNAL MODULE: ./pages/apartamentos-a-venda/[slug]/fraseVendedora.tsx
var fraseVendedora = __webpack_require__(48249);
// EXTERNAL MODULE: ./pages/apartamentos-a-venda/[slug]/galeria.tsx + 1 modules
var _slug_galeria = __webpack_require__(70500);
// EXTERNAL MODULE: ./pages/apartamentos-a-venda/[slug]/localizacao.tsx
var _slug_localizacao = __webpack_require__(94758);
// EXTERNAL MODULE: ./pages/apartamentos-a-venda/[slug]/sugestoes.tsx
var sugestoes = __webpack_require__(15732);
// EXTERNAL MODULE: ./pages/apartamentos-a-venda/[slug]/vr360.tsx
var _slug_vr360 = __webpack_require__(34353);
;// CONCATENATED MODULE: ./pages/apartamentos-a-venda/[slug]/index.tsx
/* provided dependency */ var process = __webpack_require__(83454);


















var __N_SSG = true;
function Index(param) {
    var empreendimentos = param.empreendimentos, empreendimento = param.empreendimento, imoveisDisponiveis = param.imoveisDisponiveis, depoimentos = param.depoimentos;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
    var router = (0,next_router.useRouter)();
    var rota = "https://hypeempreendimentos.com.br".concat(router.asPath);
    if (!empreendimento) return null;
    var convertDate = new ConvertDate();
    var nomeEmpreendimento = empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.empreendimento;
    var banner = (0,ImageFindSizes/* imagemSizes */.xQ)((0,ImageFindSizes/* findImage */.jw)(empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.imagens, "banner-principal"));
    var logo = (0,ImageFindSizes/* imagemSizes */.xQ)((0,ImageFindSizes/* findImage */.jw)(empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.imagens, "logo-empreendimento"));
    var conceito = (ref1 = empreendimento === null || empreendimento === void 0 ? void 0 : (ref = empreendimento.textos) === null || ref === void 0 ? void 0 : ref.find(function(txt) {
        return (txt === null || txt === void 0 ? void 0 : txt.referencia) === "conceito";
    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.texto) === null || ref2 === void 0 ? void 0 : ref2.conteudo;
    var valorMinimo = empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.valor_minimo;
    var valorMaximo = empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.valor_maximo;
    var faseObra = empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.fase_obra;
    var informacoesImagem = (ref4 = empreendimento === null || empreendimento === void 0 ? void 0 : (ref3 = empreendimento.imagens) === null || ref3 === void 0 ? void 0 : ref3.find(function(img) {
        return img.referencia === "imagem-informacoes";
    })) === null || ref4 === void 0 ? void 0 : ref4.imagem;
    var informacoesIcones = empreendimento === null || empreendimento === void 0 ? void 0 : (ref5 = empreendimento.imagens) === null || ref5 === void 0 ? void 0 : ref5.filter(function(img) {
        return img.referencia.includes("icone-informacoes");
    }).map(function(img) {
        var ref;
        return img === null || img === void 0 ? void 0 : (ref = img.imagem) === null || ref === void 0 ? void 0 : ref.url;
    });
    var informacoesItens = [
        empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.tipologia,
        empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.area_privativa,
        empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.garagem,
        empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.area_comum,
        process.env.FEATURE_FLAG_DATA_ENTREGA ? "Entrega em ".concat(convertDate.parseDateToMonthYearText(empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.entrega)) : "", 
    ];
    var localizacao = (ref7 = empreendimento === null || empreendimento === void 0 ? void 0 : (ref6 = empreendimento.textos) === null || ref6 === void 0 ? void 0 : ref6.find(function(txt) {
        return (txt === null || txt === void 0 ? void 0 : txt.referencia) === "localizacao";
    })) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.texto) === null || ref8 === void 0 ? void 0 : ref8.conteudo;
    var latitude = empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.latitude;
    var longitude = empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.longitude;
    var destaque = (ref10 = empreendimento === null || empreendimento === void 0 ? void 0 : (ref9 = empreendimento.textos) === null || ref9 === void 0 ? void 0 : ref9.find(function(txt) {
        return (txt === null || txt === void 0 ? void 0 : txt.referencia) === "destaque";
    })) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.texto) === null || ref11 === void 0 ? void 0 : ref11.conteudo;
    var ref23;
    var vr360 = (ref23 = (ref13 = empreendimento === null || empreendimento === void 0 ? void 0 : (ref12 = empreendimento.textos) === null || ref12 === void 0 ? void 0 : ref12.find(function(txt) {
        return (txt === null || txt === void 0 ? void 0 : txt.referencia) === "vr360";
    })) === null || ref13 === void 0 ? void 0 : ref13.texto) !== null && ref23 !== void 0 ? ref23 : null;
    var galeria = empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.imagens.filter(function(img) {
        var ref;
        return img === null || img === void 0 ? void 0 : (ref = img.referencia) === null || ref === void 0 ? void 0 : ref.includes("galeria");
    });
    var plantas = empreendimento === null || empreendimento === void 0 ? void 0 : (ref14 = empreendimento.imagens) === null || ref14 === void 0 ? void 0 : ref14.filter(function(img) {
        var ref;
        return img === null || img === void 0 ? void 0 : (ref = img.referencia) === null || ref === void 0 ? void 0 : ref.includes("planta");
    });
    var obra = empreendimento === null || empreendimento === void 0 ? void 0 : (ref15 = empreendimento.imagens) === null || ref15 === void 0 ? void 0 : ref15.filter(function(img) {
        var ref;
        return img === null || img === void 0 ? void 0 : (ref = img.referencia) === null || ref === void 0 ? void 0 : ref.includes("obra");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                    data: {
                        titulo: empreendimento === null || empreendimento === void 0 ? void 0 : (ref16 = empreendimento.seo) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.seo) === null || ref17 === void 0 ? void 0 : ref17.metaTitle,
                        descricao: empreendimento === null || empreendimento === void 0 ? void 0 : (ref18 = empreendimento.seo) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.seo) === null || ref19 === void 0 ? void 0 : ref19.metaDescription,
                        imagem: empreendimento === null || empreendimento === void 0 ? void 0 : (ref20 = empreendimento.seo) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.seo) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.ogImage) === null || ref22 === void 0 ? void 0 : ref22.url,
                        rota: rota
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerDefault/* default */.Z, {
                image: {
                    src: banner || ""
                },
                width: "100%",
                height: "70vh",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            objectFit: "contain",
                            width: "280px",
                            height: "280px",
                            src: logo || "",
                            loader: customLoaderImage/* customLoader */.l,
                            alt: "Logo do Empreendimento",
                            priority: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                            children: empreendimento === null || empreendimento === void 0 ? void 0 : empreendimento.empreendimento
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_slug_conceito["default"], {
                conceito: conceito,
                valorMinimo: valorMinimo,
                valorMaximo: valorMaximo,
                faseObra: faseObra
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(diferenciais["default"], {
                data: {
                    informacoesImagem: informacoesImagem,
                    informacoesIcones: informacoesIcones,
                    informacoesItens: informacoesItens
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_slug_localizacao["default"], {
                data: {
                    localizacao: localizacao,
                    latitude: latitude,
                    longitude: longitude
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(fraseVendedora["default"], {
                destaque: destaque
            }),
            vr360 && /*#__PURE__*/ (0,jsx_runtime.jsx)(_slug_vr360["default"], {
                url: vr360.conteudo,
                empreendimento: nomeEmpreendimento
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_slug_galeria["default"], {
                data: {
                    galeria: galeria,
                    plantas: plantas,
                    obra: obra
                }
            }),
            depoimentos && /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselDepoimentos/* default */.Z, {
                depoimentos: depoimentos
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(cadastro["default"], {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sugestoes["default"], {
                currentProduct: empreendimentos,
                disponibilidade: imoveisDisponiveis
            })
        ]
    });
}


/***/ }),

/***/ 94758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Localizacao; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _localizacao_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98536);
/* harmony import */ var _localizacao_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_localizacao_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var parse = __webpack_require__(30488);
function Localizacao(param) {
    var data = param.data;
    if (!data) return null;
    var localizacao = data.localizacao, latitude = data.latitude, longitude = data.longitude;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_localizacao_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: "Excelente localiza\xe7\xe3o"
            }),
            localizacao && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_localizacao_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
                children: parse(localizacao)
            }),
            latitude && longitude && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                loading: "lazy",
                title: "Mapa Empreendimento",
                src: "https://maps.google.com/maps?q=".concat("".concat(latitude, ",").concat(longitude), "&output=embed")
            })
        ]
    });
}


/***/ }),

/***/ 15732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Sugestoes; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Buttons_ButtonDefault__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59000);
/* harmony import */ var _components_Cards_CardImovel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51012);
/* harmony import */ var _components_Carousel_CarouselCardsDefault__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26476);
/* harmony import */ var _sugestoes_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87914);
/* harmony import */ var _sugestoes_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_sugestoes_module_scss__WEBPACK_IMPORTED_MODULE_7__);








function Sugestoes(param) {
    var currentProduct = param.currentProduct, disponibilidade = param.disponibilidade;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), arrayCarousel = ref[0], setArrayCarousel = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var isMounted = true;
        var genArrayCarousel = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var ref, district, dormsMin, minPrice, arrayOrdered;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    district = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.bairro;
                    dormsMin = currentProduct === null || currentProduct === void 0 ? void 0 : (ref = currentProduct.dorms) === null || ref === void 0 ? void 0 : ref.match(/\d+/g)[0];
                    minPrice = parseFloat(currentProduct.valorMinimo);
                    arrayOrdered = currentProduct.sort(function(a, b) {
                        if (a.bairro === district && b.bairro !== district) return -1;
                        if (a.bairro !== district && b.bairro === district) return 1;
                        if (a.bairro === b.bairro) {
                            if (a.numeroDeDormitorios[0] >= dormsMin && b.numeroDeDormitorios[0] < dormsMin) return -1;
                            if (a.numeroDeDormitorios[0] < dormsMin && b.numeroDeDormitorios[0] >= dormsMin) return 1;
                            if (a.numeroDeDormitorios[0] === b.numeroDeDormitorios[0]) {
                                if (a.precoMinimo <= minPrice && b.precoMinimo > minPrice) return -1;
                                if (a.precoMinimo > minPrice && b.precoMinimo <= minPrice) return 1;
                                return null;
                            }
                        }
                        return null;
                    });
                    if (isMounted) {
                        setArrayCarousel(arrayOrdered.slice(0, 5));
                    }
                    return [
                        2
                    ];
                });
            });
            return function genArrayCarousel() {
                return _ref.apply(this, arguments);
            };
        }();
        genArrayCarousel();
        isMounted = false;
    }, [
        currentProduct,
        disponibilidade
    ]);
    if (!currentProduct || !disponibilidade) return null;
    var arrayCards = arrayCarousel.map(function(imovel) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_CardImovel__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            imovel: imovel
        }, imovel.id);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_sugestoes_module_scss__WEBPACK_IMPORTED_MODULE_7___default().section),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: "Encontre o seu Apartamento"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: "Descubra as op\xe7\xf5es dispon\xedveis!"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Buttons_ButtonDefault__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                url: "/apartamentos-a-venda",
                text: "Ver todas as op\xe7\xf5es!",
                aria: "Ver todas as op\xe7\xf5es!"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Carousel_CarouselCardsDefault__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                seeMore: "/apartamentos-a-venda",
                children: arrayCards
            })
        ]
    });
}


/***/ }),

/***/ 34353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ vr360; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Buttons_ButtonDefault__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59000);
/* harmony import */ var _vr360_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43977);
/* harmony import */ var _vr360_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_vr360_module_scss__WEBPACK_IMPORTED_MODULE_3__);




function vr360(param) {
    var url = param.url, empreendimento = param.empreendimento;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_vr360_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: "Vis\xe3o 360\xb0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                children: [
                    "Fa\xe7a agora um tour virtual no",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: empreendimento
                    }),
                    "!"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Buttons_ButtonDefault__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                url: url,
                target: "_blank",
                text: "Navegar com Vis\xe3o 360\xb0",
                aria: "Navegar com Vis\xe3o 360\xb0"
            })
        ]
    });
}


/***/ }),

/***/ 34873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jw": function() { return /* binding */ findImage; },
/* harmony export */   "xQ": function() { return /* binding */ imagemSizes; }
/* harmony export */ });
/* unused harmony export imagemSizeDestructure */
// eslint-disable-next-line import/prefer-default-export
var imagemSizeDestructure = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var data = props === null || props === void 0 ? void 0 : props.imagem;
    if (data === null || data === void 0 ? void 0 : (ref = data.sizes) === null || ref === void 0 ? void 0 : (ref1 = ref.large) === null || ref1 === void 0 ? void 0 : ref1.url) {
        return data.sizes.large;
    }
    if (data === null || data === void 0 ? void 0 : (ref2 = data.sizes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.medium) === null || ref3 === void 0 ? void 0 : ref3.url) {
        return data.sizes.medium;
    }
    if (data === null || data === void 0 ? void 0 : (ref4 = data.sizes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.small) === null || ref5 === void 0 ? void 0 : ref5.url) {
        return data.sizes.small;
    }
    if (data === null || data === void 0 ? void 0 : (ref6 = data.sizes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.square) === null || ref7 === void 0 ? void 0 : ref7.url) {
        return data.sizes.square;
    }
    if (data === null || data === void 0 ? void 0 : (ref8 = data.sizes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.thumbnail) === null || ref9 === void 0 ? void 0 : ref9.url) {
        return data.sizes.thumbnail;
    }
    if (data === null || data === void 0 ? void 0 : data.url) {
        return data;
    }
    return "";
};
var imagemSizes = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var data = props === null || props === void 0 ? void 0 : props.imagem;
    if (data === null || data === void 0 ? void 0 : (ref = data.sizes) === null || ref === void 0 ? void 0 : (ref1 = ref.large) === null || ref1 === void 0 ? void 0 : ref1.url) {
        return data.sizes.large.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref2 = data.sizes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.medium) === null || ref3 === void 0 ? void 0 : ref3.url) {
        return data.sizes.medium.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref4 = data.sizes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.small) === null || ref5 === void 0 ? void 0 : ref5.url) {
        return data.sizes.small.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref6 = data.sizes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.square) === null || ref7 === void 0 ? void 0 : ref7.url) {
        return data.sizes.square.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref8 = data.sizes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.thumbnail) === null || ref9 === void 0 ? void 0 : ref9.url) {
        return data.sizes.thumbnail.url;
    }
    if (data === null || data === void 0 ? void 0 : data.url) {
        return data.url;
    }
    return "";
};
var findImage = function(imagens, referencia) {
    return imagens === null || imagens === void 0 ? void 0 : imagens.find(function(img) {
        return img.referencia === referencia;
    });
};


/***/ }),

/***/ 20362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ formatCoin; },
/* harmony export */   "o": function() { return /* binding */ valueToBRL; }
/* harmony export */ });
function formatCoin(number) {
    return Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        maximumSignificantDigits: 1
    }).format(number);
}
function valueToBRL(value) {
    return Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
    }).format(value);
}


/***/ }),

/***/ 61249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Toast; },
/* harmony export */   "P": function() { return /* binding */ ToastColor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
// How to use in component:
// import { Toast, ToastColor } from '../utils/toastNotification'
// new Toast({
//   message: 'Enviado com sucesso!',
//   color: ToastColor.Success,
//   time: 5000
// });
// ------------------------------------

var Toast = function Toast(param) {
    "use strict";
    var message = param.message, color = param.color, time = param.time;
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Toast);
    this.message = message;
    this.color = color;
    this.time = time;
    this.element = null;
    var element = document.createElement("div");
    element.className = "toast-notification";
    this.element = element;
    var countElements = document.getElementsByClassName("toast-notification");
    element.style.opacity = "0.8";
    element.style.marginBottom = countElements.length * 55 + "px";
    element.style.backgroundColor = this.color;
    element.style.width = "fit-content";
    element.style.height = "40px";
    element.style.padding = "10px";
    element.style.margin = "20px";
    element.style.borderRadius = "10px 15px";
    element.style.color = "white";
    element.style.position = "fixed";
    element.style.top = "10%";
    element.style.left = "80%";
    element.style.justifyContent = "center";
    element.style.alignItems = "center";
    element.style.zIndex = "9999";
    element.style.textAlign = "center";
    var messageToast = document.createElement("div");
    messageToast.className = "message-container";
    messageToast.textContent = this.message;
    element.appendChild(messageToast);
    document.body.appendChild(element);
    setTimeout(function() {
        element.remove();
    }, this.time);
};
var ToastColor = {
    Danger: "#eb3b5a",
    Warning: "#fdcb6e",
    Success: "#00bd97"
};


/***/ }),

/***/ 70753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ validationFormContact; }
/* harmony export */ });
/* harmony import */ var joi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42705);
/* harmony import */ var joi__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(joi__WEBPACK_IMPORTED_MODULE_0__);

var validationFormContact = joi__WEBPACK_IMPORTED_MODULE_0___default().object({
    nome: joi__WEBPACK_IMPORTED_MODULE_0___default().string().required().min(3).messages({
        "string.empty": "O campo NOME \xe9 obrigat\xf3rio!",
        "string.base": "O campo NOME deve conter apenas texto!",
        "string.min": "Digite um NOME v\xe1lido!"
    }),
    email: joi__WEBPACK_IMPORTED_MODULE_0___default().string().email({
        tlds: {
            allow: false
        }
    }).required().messages({
        "string.empty": "O campo E-MAIL \xe9 obrigat\xf3rio!",
        "string.base": "O campo E-MAIL deve ser do tipo texto!",
        "string.email": "Digite um E-MAIL v\xe1lido!"
    }),
    telefone: joi__WEBPACK_IMPORTED_MODULE_0___default().string().min(10).required().messages({
        "string.pattern.base": "Digite um n\xfamero de TELEFONE v\xe1lido!",
        "string.empty": "O campo TELEFONE \xe9 obrigat\xf3rio!",
        "string.min": "Digite um n\xfamero de TELEFONE v\xe1lido!"
    }),
    momento: joi__WEBPACK_IMPORTED_MODULE_0___default().string().required().messages({
        "string.empty": "Por favor, indique o seu momento atual!"
    }),
    empreendimento: joi__WEBPACK_IMPORTED_MODULE_0___default().string().required().messages({
        "string.empty": "Campo EMPREENDIMENTO obrigat\xf3rio!"
    }),
    horario: joi__WEBPACK_IMPORTED_MODULE_0___default().string().required().messages({
        "string.empty": "Campo HOR\xc1RIO obrigat\xe1rio!"
    }),
    canal: joi__WEBPACK_IMPORTED_MODULE_0___default().string().required().messages({
        "string.empty": "Campo CANAL obrigat\xe1rio!"
    }),
    criadoEm: joi__WEBPACK_IMPORTED_MODULE_0___default().date().required().messages({
        "string.empty": "Campo DATA obrigat\xf3rio!"
    })
});


/***/ }),

/***/ 67202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"bannerDefault_bannerContainer___FPrj","childrenContainer":"bannerDefault_childrenContainer__kGyT8"};

/***/ }),

/***/ 90050:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"buttonDefault_buttonContainer__0nGtF"};

/***/ }),

/***/ 30985:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardImovel":"cardImovel_cardImovel__Se9Qo","image":"cardImovel_image__W5AiJ","text":"cardImovel_text__HMkQw"};

/***/ }),

/***/ 84746:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"carouselDepoimentos_section__ygJ__","slider":"carouselDepoimentos_slider__60Kit","slide":"carouselDepoimentos_slide__KbjvB","cliente":"carouselDepoimentos_cliente__kq_hw","image":"carouselDepoimentos_image__Mi1bh","infoClient":"carouselDepoimentos_infoClient__iuaz4"};

/***/ }),

/***/ 16360:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gallery":"galeryDesktopCarousel_gallery__65wuX","containerImages":"galeryDesktopCarousel_containerImages__TMvOO"};

/***/ }),

/***/ 49593:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider":"galeryMobileCarousel_slider__iP1ZD","slide":"galeryMobileCarousel_slide__QQztt"};

/***/ }),

/***/ 43465:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"cadastroDefault_formContainer__5cDFE","fieldItem":"cadastroDefault_fieldItem__sP6Db","fieldCanal":"cadastroDefault_fieldCanal__6_4PP","errorMessage":"cadastroDefault_errorMessage__vaPhb","contacts":"cadastroDefault_contacts__bLh1_","iconContact":"cadastroDefault_iconContact__76XCe"};

/***/ }),

/***/ 48247:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cadastroForm":"cadastro_cadastroForm__H771j"};

/***/ }),

/***/ 66956:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"conceito_section__2IGIu","preco":"conceito_preco__kT8XO"};

/***/ }),

/***/ 12733:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"diferenciais_section__CmJOU","image":"diferenciais_image__sN_5_","contentTab":"diferenciais_contentTab__OQmlO","icon":"diferenciais_icon__fEnVM"};

/***/ }),

/***/ 24191:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"fraseVendedora_section__FrmUy"};

/***/ }),

/***/ 97740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gallery":"galeria_gallery__lkL1S","tabNotClicked":"galeria_tabNotClicked__NqiX9","tabClicked":"galeria_tabClicked__s5pjC","tabs":"galeria_tabs__XfVlk","contentTab":"galeria_contentTab__aZoRL","containerImages":"galeria_containerImages__dNRwb","image":"galeria_image__cp5CQ","sudo":"galeria_sudo__S1q3G"};

/***/ }),

/***/ 98536:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"localizacao_section__UKr86"};

/***/ }),

/***/ 87914:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"sugestoes_section__SDWkB"};

/***/ }),

/***/ 43977:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"vr360_section__GTTWk"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3336,6319,2794,4615,9520,3829,194,1072,9565,3355,6476,9774,2888,179], function() { return __webpack_exec__(24050); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);